<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <!-- shape Hero -->
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('app.bosh_hudud')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--100">
            <div class="container">
                <el-row :gutter="15" class="row-grid">
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim3')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil3')}}</p>
                            <div>
                                <badge type="primary" rounded>tel:0361 222-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps?q=42.462555,59.620072&ll=42.462555,59.620072&z=16"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim4')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil4')}}</p>
                            <div>
                                <badge type="primary" rounded>tel:0374 227-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps?q=40.770238,72.361077&ll=40.770238,72.361077&z=16"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim5')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil5')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0365 221-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/39%C2%B046'10.2%22N+64%C2%B025'24.0%22E/@39.7694951,64.4211493,859m/data=!3m2!1e3!4b1!4m14!1m7!3m6!1s0x0:0x0!2zMznCsDQ1JzU1LjQiTiA2NMKwMjUnNDAuOCJF!3b1!8m2!3d39.765376!4d64.427993!3m5!1s0x0:0x0!7e2!8m2!3d39.769491!4d64.4233384"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim13')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil13')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0373 244-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/Oriyat+Street,+Fergana/@40.3792363,71.7731619,14.58z/data=!4m5!3m4!1s0x38bb836190d062d9:0x56eeb5c906bc75b6!8m2!3d40.3838488!4d71.790837"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim6')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil6')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0372 226-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps?q=40.134100,67.819669&ll=40.134100,67.819669&z=16"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim9')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil9')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0369 227-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/6+Chilanzar+Street,+Tashkent+100115,+Uzbekistan/@41.2866534,69.2257316,17z/data=!4m8!1m2!2m1!1z0KLQvtGI0LrQtdC90YIg0YguLCDQp9C40LvQvtC90LfQvtGAINC60Z7Rh9Cw0YHQuCw2!3m4!1s0x38ae8a454b0cf619:0xe6ccc5a964d82fa7!8m2!3d41.2866534!4d69.2279206"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim8')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil8')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0436 210-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps?q=40.080271,65.377216&ll=40.080271,65.377216&z=16"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim7')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil7')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0375 228-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps?q=38.838418,65.803369&ll=38.838418,65.803369&z=16"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim10')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil10')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0366 232-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/6+Chilanzar+Street,+Tashkent+100115,+Uzbekistan/@41.2866534,69.2257316,17z/data=!4m8!1m2!2m1!1z0KLQvtGI0LrQtdC90YIg0YguLCDQp9C40LvQvtC90LfQvtGAINC60Z7Rh9Cw0YHQuCw2!3m4!1s0x38ae8a454b0cf619:0xe6ccc5a964d82fa7!8m2!3d41.2866534!4d69.2279206"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim12')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil12')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0367 235-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps?q=40.499209,68.777940&ll=40.499209,68.777940&z=16"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim11')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil11')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0376 223-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/Surkhandar'inskaya+Oblast/@37.2266337,67.2708857,17z/data=!3m1!4b1!4m5!3m4!1s0x3f352e04cd839e43:0x96bd3d23467cd802!8m2!3d37.2266294!4d67.2730744"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim1')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil1')}}</p>
                            <div>
                                <badge type="primary" rounded>tel:0371 271-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/Prokuratura+Goroda+Tashkenta/@41.2868808,69.2260561,17.5z/data=!4m8!1m2!2m1!1zMTAwMTE1LCDQotC-0YjQutC10L3RgiDRiC4sINCn0LjQu9C-0L3Qt9C-0YAg0LrRntGH0LDRgdC4LDY!3m4!1s0x38ae8a456a8f1c07:0x801314a21a38384!8m2!3d41.2867814!4d69.2271039"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim2')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil2')}}</p>
                            <div>
                                <badge type="primary" rounded>tel:0371 230-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/%D0%9F%D1%80%D0%BE%D0%BA%D1%83%D1%80%D0%B0%D1%82%D1%83%D1%80%D0%B0+%D0%A2%D0%B0%D1%88%D0%BA%D0%B5%D0%BD%D1%82%D1%81%D0%BA%D0%BE%D0%B9+%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D0%B8+*+%D0%A2%D0%BE%D1%88%D0%BA%D0%B5%D0%BD%D1%82+%D0%B2%D0%B8%D0%BB%D0%BE%D1%8F%D1%82%D0%B8+%D0%BF%D1%80%D0%BE%D0%BA%D1%83%D1%80%D0%B0%D1%82%D1%83%D1%80%D0%B0%D1%81%D0%B8/@41.0660048,69.3377828,17z/data=!4m5!3m4!1s0x38ae8a3a18d592b1:0x3b62e110fa7841a5!8m2!3d41.0660008!4d69.3399715"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim14')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil14')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0362 227-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/41%C2%B032'39.3%22N+60%C2%B037'13.6%22E/@41.544245,60.6182473,17z/data=!3m1!4b1!4m6!3m5!1s0!7e2!8m2!3d41.5442453!4d60.6204356"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim15')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil15')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0371 207-11-59</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/Byuro+Prinuditel'nogo+Ispolneniya/@41.330428,69.2905591,17.21z/data=!4m8!1m2!2m1!1z0JzQkNCW0JHQo9Cg0JjQmSDQmNCW0KDQniDQkdCu0KDQntCh0Jg!3m4!1s0x38aef4b50c0ea0e1:0x6ef5f3c675e6de75!8m2!3d41.3296089!4d69.2903329"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim16')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil16')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0371 232-01-71</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/6+Chilanzar+Street,+Tashkent+100115,+Uzbekistan/@41.2866534,69.2257316,17z/data=!4m8!1m2!2m1!1z0KLQvtGI0LrQtdC90YIg0YguLCDQp9C40LvQvtC90LfQvtGAINC60Z7Rh9Cw0YHQuCw2!3m4!1s0x38ae8a454b0cf619:0xe6ccc5a964d82fa7!8m2!3d41.2866534!4d69.2279206"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim17')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil17')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0371 233-10-07</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/6+Chilanzar+Street,+Tashkent+100115,+Uzbekistan/@41.2866534,69.2257316,17z/data=!4m8!1m2!2m1!1z0KLQvtGI0LrQtdC90YIg0YguLCDQp9C40LvQvtC90LfQvtGAINC60Z7Rh9Cw0YHQuCw2!3m4!1s0x38ae8a454b0cf619:0xe6ccc5a964d82fa7!8m2!3d41.2866534!4d69.2279206"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                    <el-col :sm="12" :md="8" :lg="6" class="mb-3" style="min-height: 205px; display: inline-grid;">
                        <card class="border-0 text-center" shadow body-classes="py-2">
                            <icon name="ni ni-briefcase-24" type="primary" rounded class="mb-2">
                                <span class="icon_location"><i class="fa fa-university"></i></span>
                            </icon>
                            <h6 class="text-primary new_title_tizim text-uppercase">{{$t('prokuraturaTizimi.tizim18')}}</h6>
                            <p class="description new_subtitle mt-1">{{$t('prokuraturaTizimi.manzil18')}}</p>
                            <div>
                                <badge type="primary" rounded>tel: 0371 299-94-00</badge>
                            </div>
                            <base-button tag="a" target="_blank"
                                         href="https://www.google.com/maps/place/41%C2%B017'37.3%22N+69%C2%B017'11.2%22E/@41.2936984,69.2842557,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d41.2936944!4d69.2864444"
                                         type="primary" class="mt-2 button_loc"><span><i class="fa fa-map-marker"></i></span>
                                {{$t('prokuraturaTizimi.map')}}
                            </base-button>
                        </card>
                    </el-col>
                </el-row>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: "home",
        components: {}
    };
</script>

<style scoped>
    .button_loc {
        /*display: block;*/
        background-color: #394869;
        border-color: #394869;
        position: absolute;
        bottom: 15px;
        font-size: 12px;
        left: 0px;
        white-space: inherit;
        line-height: 1;
        font-weight: 500;
        margin-right: 0px !important;
        margin-left: 0px !important;
    }

    .icon_location {
        margin-left: 2px;
        font-size: 19px;
    }
    .new_title_tizim {
        color: #394869 !important;
        font-size: 13px;
    }
    .new_subtitle {
        line-height: 1.2;
        font-size: 12px;
        margin-bottom: 5px;
    }
    /deep/ .icon-shape-primary {
        color: #394869;
        background-color: rgba(186, 206, 226, 0.5);
    }
    /deep/ .btn-primary:hover {
        color: #fff;
        background-color: #003169;
        border-color: #003169;
    }
</style>